import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../../my-app/src/environments/environment';

const AGENT_API_URL = environment.agentApiUrl;

@Injectable({
  providedIn: 'root'
})
export class ChatApiService {
  private _sessionId: string | null = null;

  constructor(
    private http: HttpClient,
    private keycloakService: KeycloakService
  ) { }

  /**
   * Sends a message to the agent API and processes the response.
   * @param message The message from the user.
   */
  async sendMessage(
  message: string,
  tableData?: any[],
  jsonData?: any
): Promise<Observable<any>> {

  const isLoggedIn = await this.keycloakService.isLoggedIn();
  let userId = 'anonymous';
  let token = '';

  if (isLoggedIn) {
    const kc = this.keycloakService.getKeycloakInstance();
    token = kc.token || '';
    userId = kc.tokenParsed?.['sub'] || 'anonymous';
  }

  const requestPayload: any = {
    session_id: this._sessionId || null,  // <--- if null, backend should create or error
    message: message,
    
  };

  if (tableData) requestPayload.parts.push({ table: tableData });
  if (jsonData) requestPayload.parts.push({ json: jsonData });

  const headers: any = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  return this.http.post<any>(`${AGENT_API_URL}/chat`, requestPayload, { headers }).pipe(
    tap(response => {
      // backend may return updated session
      if (response?.session_id) {
        this._sessionId = response.session_id;
      }
    })
  );
}




async createSession() {
  const isLoggedIn = await this.keycloakService.isLoggedIn();
  let userId = 'anonymous';
  const appName = "user_workflow_agent";

  if (isLoggedIn) {
    userId = this.keycloakService.getKeycloakInstance().tokenParsed?.['sub'] || 'anonymous';
  }

  // CLEAR PREVIOUS SESSION ID BEFORE CREATING NEW ONE
  this._sessionId = null;

  const sessionApiUrl = `${AGENT_API_URL}/apps/${appName}/users/${userId}/sessions`;

  return this.http.post<any>(sessionApiUrl, {}).pipe(
    tap(response => {
      console.log('Session creation response:', response);

      if (response?.id) {
        this._sessionId = response.id;    // <-- store new fresh session
      }
    })
  );
}


}